import React from 'react';
import {
  FormControlLabel, FormHelperText, Radio, RadioGroup,
} from '@mui/material';
import { Controller } from 'react-hook-form';

const VehicleRadio = ({ control }) => (
  <Controller
    name="vehicleType"
    control={control}
    rules={{ required: 'This field is required.' }}
    render={
      ({
        field,
        fieldState,
      }) => (
        <>
          <div>
            <RadioGroup
              id="vehicle-radio"
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              name={field.name}
            >
              <FormControlLabel value="automobile" control={<Radio />} label="Automobile" />
              <FormControlLabel value="motorcycle" control={<Radio />} label="Motorcycle" />
              <FormControlLabel value="recreational" control={<Radio />} label="RV" />
            </RadioGroup>
          </div>
          {fieldState.invalid && (
            <FormHelperText error>
              {fieldState.error.message}
            </FormHelperText>
          )}
        </>
      )
    }
  />
);

export default VehicleRadio;
